import apiClient from './client'

/**
 * Validar o rechazar un archivo: una decisión DEFINITIVA, a nombre de quien
 * la toma (el servidor pone `reviewer_id` desde el token, nunca el navegador).
 *
 * La usan Mi bandeja —el ejecutivo, sobre SUS conversaciones— y En vivo
 * —supervisión y admin, sobre cualquiera y SIN tomarla (Ruben, 20-oct-2026)—.
 * Es una sola función para que los dos lugares manden lo mismo: el motivo
 * del rechazo viaja como `notes`, el revisor lo guarda en `human_notes` y la
 * Ficha lo muestra.
 *
 * No le habla al cliente ni cambia quién atiende: lleva la decisión al
 * checklist y nada más. «Pedir de nuevo» es otra cosa —un mensaje al
 * cliente— y no pasa por acá.
 */
export function registrarRevision(docId: string, accion: 'approve' | 'reject', motivo = '') {
  return apiClient.post(`/documents/${docId}/review`, {
    decision: accion === 'approve' ? 'APPROVED' : 'REJECTED',
    ...(motivo ? { notes: motivo } : {}),
  })
}
